import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UtilsModule } from 'src/app/utils/utils.module';
// import { HttpLoaderFactory } from '../landing-page/header/header.module';

import { CycloneComponent } from './cyclone/cyclone.component';
import { DrinkingWaterStressComponent } from './drinking-water-stress/drinking-water-stress.component';
import { DroughtDashboardComponent } from './drought-dashboard/drought-dashboard.component';
import { ExtremeWeatherComponent } from './extreme-weather/extreme-weather.component';
import { BottombarMenusModule } from './flood-forecast/bottombar-menus/bottombar-menus.module';
import { FloodForecastComponent } from './flood-forecast/flood-forecast.component';
import { HeatIndexComponent } from './heat-index/heat-index.component';
import { NowcastDashboardComponent } from './nowcast-dashboard/nowcast-dashboard.component';
import { ObservedWeatherComponent } from './observed-weather/observed-weather.component';
import { SideBarComponent } from './side-bar.component';
import { AlertComponent } from './alert/alert.component';
import { RainfallActualComponent } from './rainfall-actual/rainfall-actual.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ToastrModule } from 'ngx-toastr';
import { WeatherdataComponent } from './weatherdata/weatherdata.component';
import { HeatwaveSidebarComponent } from './heat-watch/heatwave/heatwave-sidebar/heatwave-sidebar.component';
import { HeatindexSidebarComponent } from './heat-watch/heatindex/heatindex-sidebar/heatindex-sidebar.component';
import { ThunderStormSidebarComponent } from './thunderstorm/thunder-storm/thunder-storm-sidebar/thunder-storm-sidebar.component';
import { ColdwaveSidebarComponent } from './cold-watch/coldwave/coldwave-sidebar/coldwave-sidebar.component';
import { NowcastSidebarComponent } from './nowcast-dashboard-v2/nowcast/nowcast-sidebar/nowcast-sidebar.component';
import { StationWarningSidebarComponent } from './nowcast-dashboard-v2/station-warning/station-warning-sidebar/station-warning-sidebar.component';
import { KolkataEventSidebarComponent } from './nowcast-dashboard-v2/kolkata-event/kolkata-event-sidebar/kolkata-event-sidebar.component';
import { RainfallForecastSidebarComponent } from './weather-forecast/rainfall-forecast/rainfall-forecast-sidebar/rainfall-forecast-sidebar.component';
import { TemperatureForecastSidebarComponent } from './weather-forecast/temperature-forecast/temperature-forecast-sidebar/temperature-forecast-sidebar.component';
import { WindSpeedForecastSidebarComponent } from './forecast/wind-speed-forecast/wind-speed-forecast-sidebar/wind-speed-forecast-sidebar.component';
import { RainfallActualSidebarComponent } from './weather-forecast/rainfall-actual/rainfall-actual-sidebar/rainfall-actual-sidebar.component';
import { SeamlessRfViewSidebarComponent } from './nowcast-dashboard-v2/seamless-rf-view/seamless-rf-view-sidebar/seamless-rf-view-sidebar.component';
import { KolkataNowcastSidebarComponent } from './nowcast-dashboard-v2/kolkata-nowcast/kolkata-nowcast-sidebar/kolkata-nowcast-sidebar.component';
import { SeamlessRainfallSidebarComponent } from './weather-forecast/seamless-rainfall/seamless-rainfall-sidebar/seamless-rainfall-sidebar.component';
import { AbgSiteSidebarComponent } from './weather-forecast/abg-site/abg-site-sidebar/abg-site-sidebar.component';
import { RainfallActualQcSidebarComponent } from './weather-forecast/rainfall-actual-qc/rainfall-actual-qc-sidebar/rainfall-actual-qc-sidebar.component';
import { EventSidebarComponent } from './nowcast-dashboard-v2/kolkata-2025-event/event-sidebar/event-sidebar.component';
import { JammuEventSidebarComponent } from './nowcast-dashboard-v2/jammu-event/jammu-event-sidebar/jammu-event-sidebar.component';
import { DisasterMonitoringSidebarComponent } from './disaster-monitoring/monitor-dashboard/disaster-monitoring-sidebar/disaster-monitoring-sidebar.component';
import { FogSidebarComponent } from './fog-watch/fog-dashboard/fog-sidebar/fog-sidebar.component';
import { SdmpSidebarComponent } from './sdmp/sdmp-dashboard/sdmp-sidebar/sdmp-sidebar.component';
import { SnowSidebarComponent } from './snow-watch/snow-dashboard/snow-sidebar/snow-sidebar.component'; // ADD THIS
import { LandSurfaceTempSidebarComponent } from './heat-watch/land-surface-temp/land-surface-temp-sidebar/land-surface-temp-sidebar.component';
import { SeamlessTempSidebarComponent } from './heat-watch/seamless-temp/seamless-temp-sidebar/seamless-temp-sidebar.component';
import { LightningSidebarComponent } from './lightning/lightning-dashboard/lightning-sidebar/lightning-sidebar.component';
import { HeatLogSidebarComponent } from './heat-watch/heat-log/heat-log-sidebar/heat-log-sidebar.component';
import { SeasonalTempSidebarComponent } from './heat-watch/seasonal-temp/seasonal-temp-sidebar/seasonal-temp-sidebar.component';
import { LandSubsidenceSidebarComponent } from './land-subsidence/land-subsidence-dashboard/land-subsidence-sidebar/land-subsidence-sidebar.component';
import { SatelliteSidebarComponent } from './satellite/sidebar/satellite-sidebar.component';
import { DrySpellSidebarComponent } from './dry-spell/dry-spell-sidebar/dry-spell-sidebar.component';
import { HumidityForecastSidebarComponent } from './forecast/humidity-forecast/humidity-forecast-sidebar/humidity-forecast-sidebar.component';
import { UvForecastSidebarComponent } from './forecast/uv-forecast/uv-forecast-sidebar/uv-forecast-sidebar.component';
import { MetwiseAlertsSidebarComponent } from './metwise-alerts/metwise-alerts-dashboard/metwise-alerts-sidebar/metwise-alerts-sidebar.component';
import { UrbanHeatIslandSidebarComponent } from './urban-heat-island/urban-heat-island-dashboard/urban-heat-island-sidebar/urban-heat-island-sidebar.component';
import { MetmindSidebarComponent } from './metmind/metmind-dashboard/metmind-sidebar/metmind-sidebar.component';
import { DroughtSidebarComponent } from './drought/drought-sidebar/drought-sidebar.component';
import { CropYieldSidebarComponent } from './crop-yield/crop-yield-sidebar/crop-yield-sidebar.component';

@NgModule({
  declarations: [
    SideBarComponent,
    ExtremeWeatherComponent,
    HeatIndexComponent,
    CycloneComponent,
    ObservedWeatherComponent,
    DroughtDashboardComponent,
    FloodForecastComponent,
    NowcastDashboardComponent,
    DrinkingWaterStressComponent,
    LightningSidebarComponent,
    AlertComponent,
    RainfallActualComponent,
    WeatherdataComponent,
    HeatwaveSidebarComponent,
    HeatindexSidebarComponent,
    ThunderStormSidebarComponent,
    ColdwaveSidebarComponent,
    NowcastSidebarComponent,
    SeamlessRfViewSidebarComponent,
    StationWarningSidebarComponent,
    KolkataEventSidebarComponent,
    RainfallForecastSidebarComponent,
    TemperatureForecastSidebarComponent,
    WindSpeedForecastSidebarComponent,
    HumidityForecastSidebarComponent,
    UvForecastSidebarComponent,
    RainfallActualSidebarComponent,
    KolkataNowcastSidebarComponent,
    SeamlessRainfallSidebarComponent,
    AbgSiteSidebarComponent,
    RainfallActualQcSidebarComponent,
    EventSidebarComponent,
    JammuEventSidebarComponent,
    DisasterMonitoringSidebarComponent,
    FogSidebarComponent,
    SnowSidebarComponent,
    LandSurfaceTempSidebarComponent,
    SeamlessTempSidebarComponent,
    HeatLogSidebarComponent,
    SeasonalTempSidebarComponent,
    LightningSidebarComponent,
    LandSubsidenceSidebarComponent,
    SatelliteSidebarComponent,
    DrySpellSidebarComponent,
    MetwiseAlertsSidebarComponent,
    UrbanHeatIslandSidebarComponent,
    MetmindSidebarComponent,
    DroughtSidebarComponent,
    CropYieldSidebarComponent,
    SdmpSidebarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    UtilsModule,
    NgSelectModule,
    BottombarMenusModule,
    ToastrModule
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
  ],
  exports: [
    SideBarComponent,
    ExtremeWeatherComponent,
    HeatIndexComponent,
    CycloneComponent,
    ObservedWeatherComponent,
    DroughtDashboardComponent,
    FloodForecastComponent,
    NowcastDashboardComponent,
    DrinkingWaterStressComponent,
    AlertComponent,
    WeatherdataComponent,
    RainfallActualComponent,
  ],
})
export class SideBarModule {}
